import styled, { keyframes } from 'styled-components';
import { mediaSizes } from 'src/theme';

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

export const Container = styled.div`
  align-items: center;
  background-color: #ffffff;
  border-bottom: 1px solid #c5d0d7;
  display: flex;
  height: 72px;
  top: 0;
  width: 100%;
  z-index: 10;

  @media (max-width: ${mediaSizes.largePhone}px) {
    padding: 0 2.5%;
  }
`;

export const InnerContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  max-width: ${({ theme }) => theme.customized.maxSiteWidth}px;
  width: 100%;
`;

export const SkeletonLogo = styled.div`
  animation: ${shimmer} 1.5s ease-in-out infinite;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.06) 0px, rgba(0, 0, 0, 0.1) 40px, rgba(0, 0, 0, 0.06) 80px);
  background-size: 200px 100%;
  border-radius: 4px;
  height: 44px;
  margin-left: 2px;
  width: 120px;
`;

export const LinksContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const SkeletonLink = styled.div`
  animation: ${shimmer} 1.5s ease-in-out infinite;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.06) 0px, rgba(0, 0, 0, 0.1) 40px, rgba(0, 0, 0, 0.06) 80px);
  background-size: 200px 100%;
  border-radius: 4px;
  height: 16px;
  width: 80px;
`;
